import { GridLegacy as Grid, Paper, Stack, useTheme } from "@mui/material";
import { useEffect } from "react";
import { Outlet, useMatch, useNavigate } from "react-router-dom";
import { ActivityStepper } from "../Activities/ActivityStepper";
import { useReportDetails } from "../useReportDetails";

// Backward compatibility wrapper - maintains existing fulfillment interface
export function WorkflowLogs() {
  const theme = useTheme();
  const { data } = useReportDetails();
  const currentActivityId =
    data?.tierIIReport.currentWorkflow?.currentActivityId;

  const shouldAutoNavigateToCurrentActivity = useMatch(
    "/staff/fulfillment/r/:reportId/workflow-logs"
  );
  const navigate = useNavigate();

  useEffect(() => {
    if (shouldAutoNavigateToCurrentActivity && currentActivityId) {
      navigate(currentActivityId, { replace: true });
    }
  }, [currentActivityId, navigate, shouldAutoNavigateToCurrentActivity]);

  return (
    <Paper sx={{ paddingTop: theme.spacing(2) }} elevation={0}>
      <Grid container spacing={theme.spacing(2)} minHeight={"500px"}>
        <Grid
          item
          xs={4}
          sx={{ borderRight: `solid 1px ${theme.palette.divider}` }}
        >
          <Stack direction="column" spacing={2}>
            <ActivityStepper />
          </Stack>
        </Grid>
        <Grid item xs={8}>
          <Outlet />
        </Grid>
      </Grid>
    </Paper>
  );
}
